import * as THREE from 'three';

// import 'three-examples/controls/OrbitControls';

export default THREE;



//////////////////
// WEBPACK FOOTER
// ./src/misc/external/three.js
// module id = IefG
// module chunks = 1